// extracted by mini-css-extract-plugin
export var typingIndicator = "_ny-0";